export default `
<h1>Frequently Asked Questions | <a href="https://cis.polite.edu.sg/lib/Common_Identity_System_Student_Guide.pdf" target="_blank">User Guide</a></h1>

<h3>1. How can I log in without a Student ID?</h3>

<p>
When you are logging in from Skills Training & Enhancement Portal (STEP), you will be redirected to a secure system for authentication. If it is your first time logging in to STEP, please sign in using your Singpass. If you do not have Singpass, you can log in using your personal email.
</br></br>
If you are logging in via your email for the first time, enter your personal email to receive a one-time code (OTP). Once you have entered the email OTP, click Login to access the Skills Training & Enhancement Portal (STEP).
</p>

<h3>2. How do I register for a Student ID?</h3>

<p>
Upon successful enrolment into a course applied through the Skills Training & Enhancement Portal (STEP), you will receive an email with your unique Student ID with instructions to complete your Student Account setup.
</p>

<h3>3. Where can I get help? </h3>

<p>
Refer to the <a href="https://cis.polite.edu.sg/lib/Common_Identity_System_Student_Guide.pdf" target="_blank">User Guide</a> for step-by-step instructions on how to set up your student account, change your password, or set alternative 2FA methods. Should you need any further assistance, click 'Contact' in the page footer to reach out to the relevant IHL helpdesk. 
</p>

<h3>4. How do I keep my account secured?</h3>

<p>
For security purposes, it is mandated for enrolled students to set up their 2FA during the first-time account set up. The additional security verification feature cannot be turned off as it helps to protect your account and data. 
</p>

<h3>5. How do I do a self-service password reset? </h3>

<p>
You can perform a self-service password reset <a href="https://cis.polite.edu.sg/changepassword" target="_blank">here</a>. Refer to the <a href="https://cis.polite.edu.sg/lib/Common_Identity_System_Student_Guide.pdf" target="_blank">User Guide</a> for step-by-step instructions on how you can perform the password reset. 
</p>

<h3>6. How do I retrieve my Student ID or re-enable my inactive account?</h3>

<p>
If you have forgotten your Student ID or if you would like to re-enable your inactive Student Account, you can do so either using Singpass or Email OTP. Please use your email registered with the Skills Training & Enhancement Portal (STEP) to retrieve an Email OTP. You may refer to the <a href="https://cis.polite.edu.sg/lib/Common_Identity_System_Student_Guide.pdf" target="_blank">User Guide</a> for step-by-step instructions on how to do so. 
</p>

<h3>7. I have been issued an NRIC due to my successful PR application, do I log into STEP with my new NRIC via Singpass?</h3>

<p>
Please do not log in to STEP with your Singpass. Instead, log in to STEP with your Student ID and password. Thereafter, you can update your FIN number to your newly issued NRIC number under Student Profile > Personal Particulars > Personal information (Request to update button). In this way, you can retain your Student ID with your updated NRIC number, along with your learning history. 
</p>

<h3>8. I received an error message saying that my login is refused by application policy, why is this so?</h3>

<p>
Should you have a valid login account but encounter issues upon log in, please reach out to the respective IHL helpdesk for support by clicking 'Contact' in the page footer.
</p>

<h3>9. How to report an issue?</h3>

If you feel that your account has been compromised, we advise you to take the following actions:
<ul>
<li>Perform a self-service password reset <a href="https://cis.polite.edu.sg/changepassword" target="_blank">here</a>.</li>
<li>Should you need any further assistance, click on Contact in the footer to reach out to the relevant IHL helpdesk.</li>
</ul>
`;